var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('header', {
    staticClass: "pointer-events-none",
    class: [_vm.fixed ? 'fixed' : 'absolute']
  }, [_c('div', {
    staticClass: "content justify-between"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "pointer-events-auto links"
  }, [_c('button', {
    staticClass: "ml-2 button--filled button--mint",
    on: {
      "click": () => _vm.onSignupClick()
    }
  }, [_c('span', [_vm._v("Apply Now")])])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("assets/images/extra-logo-white.svg"),
      "alt": "Extra logo"
    }
  })]);
}];
export { render, staticRenderFns };